import React from 'react';

import $ from '../../../../offline/jquery.min.js';
import ConfigService from "../../../Services/api/Config";
import Utils from "../../../Services/Utils";
import classNames from "classnames";

class Icon extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      svg: null,
      hover: false,
      loaded: false,
    };
    this.element = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setSVG();
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const { color, children } = this.props;

    if (children.props) {
      if (children.props.alt !== prevProps.children.props.alt) {
        setTimeout(() => {
          this.setSVG();
        }, 0);
      }
    }

    if (this.state.loaded) {
      if (color !== prevProps.color) {
        this.setColor();
      }
      else {
        const obj1 = Array.isArray(children) && children.length > 0 ? children[0] : children;
        const obj2 = Array.isArray(prevProps.children) && prevProps.children.length > 0 ? prevProps.children[0] : children;
        if (!Object.is(obj1,obj2)) {
          setTimeout(() => {
            this.setSVG();
          }, 0);
        }
      }
    }

  }

  setPosition = () => {
    const { position, height, width } = this.props;
    if (this.element && this.element.current) {
      const element = $(this.element.current);
      element.parent().addClass('Relative');
      element.css('height', height + 'px');
      element.css('width', width + 'px');
      var positions = position.split(' ');
      angular.forEach(positions, function (position) {
        switch (position) {
          case 'Top':
            element.css('bottom', 'auto');
            break;
          case 'Bottom':
            element.css('top', 'auto');
            break;
          case 'Left':
            element.css('right', 'auto');
            break;
          case 'Right':
            element.css('left', 'auto');
            break;
        }
      });
    }
  };

  setZoneColor = (zone, color) => {
    const { changeColor } = this.props;
    const changeColorIcon = changeColor ? ConfigService.getDefaultColor(changeColor) : null;
    if (this.state.svg) {
      this.state.svg.find(zone).each(function (i) {
        const path = $(this);
        let fill = path.attr('fill');
        let changed = path.attr('changed');
        if (Utils.isNull(fill)) {
          fill = path.parent().attr('fill');
        }
        if (fill) {
          fill = fill.toLowerCase();
        }
        if (changed || ((fill !== '#fff') && (fill !== '#ffffff'))) {
          if (changeColorIcon) {
            const colorChanged = changed ? changed.toLowerCase() : changeColorIcon.toLowerCase();
            if (fill === colorChanged) {
              path.attr('fill', color);
              path.attr('changed', color);
            }
          }
          else {
            path.attr('fill', color);
          }
        }
      });
    }
  };

  setColor = (hoverColor) => {
    const { color, opacity } = this.props;
    const colorElement = hoverColor || color;
    let colorIcon = null;
    if (colorElement === 'white') {
      colorIcon = '#FFFFFF';
    }
    else {
      colorIcon = colorElement ? ConfigService.getColor(colorElement, opacity) : null;
    }
    if (this.state.svg && this.state.svg.length > 0 && colorIcon) {
      this.setZoneColor('path', colorIcon);
      this.setZoneColor('polygon', colorIcon);
      this.setZoneColor('rect', colorIcon);
      this.setZoneColor('circle', colorIcon);
    }
  };

  setSVG = () => {
    const { height, width, position, id } = this.props;
    let svg = null;
    if (this.element && this.element.current) {
      svg = $(this.element.current).find('svg');
    }
    if (svg && svg.length > 0) {
      // Remove any invalid XML tags as per http://validator.w3.org
      svg.removeAttr('xmlns:a');

      svg.attr('height', height);
      svg.attr('width', width);
      svg.attr('viewBox', '0 0 ' + width + ' ' + height);
      if(id){
        svg.attr('id', id);
      }
      this.setState({svg: svg});
      this.setColor();
      if (position) {
        this.setPosition();
      }
      setTimeout(() => {
        this.setState({loaded: true});
      }, 0);
    }
  };

  onMouseOver = (onMouseFunction) => {
    const { hoverColor } = this.props;
    if (!Utils.isEmpty(onMouseFunction)) {
      onMouseFunction();
    }
    if (!this.state.hover) {
      if (hoverColor) {
        this.setColor(hoverColor);
      }
    }
    this.setState({hover: true});
  };

  onMouseLeave = (onMouseFunction) => {
    const { hoverColor } = this.props;
    if (!Utils.isEmpty(onMouseFunction)) {
      onMouseFunction();
    }
    if (this.state.hover){
      if (hoverColor) {
        this.setColor();
      }
    }
    this.setState({hover: false});
  };

  render() {
    const {
      className,
      onClick,
      height,
      width,
      position,
      onMouseOver,
      onMouseLeave,
      children
    } = this.props;

    return (
      <div
        ref={ this.element }
        className={
          classNames('Icon Inline', className, {
            'Pointer' : !Utils.isNull(onClick),
            'Absolute' : !Utils.isNull(position),
            'Hidden' : !this.state.loaded
          })
        }
        onClick={ onClick }
        onMouseOver={ () => this.onMouseOver(onMouseOver) }
        onMouseLeave={ () => this.onMouseLeave(onMouseLeave) }
        style={ { height: height + 'px', width: width + 'px'} }
      >
        { children }
      </div>
    );
  }
}

export default Icon;